<template>
  <div>
    <!-- 主页 -->
    <div class="mmcs">
      <!-- top -->
      <div class="mmcs-top">
        <!-- top-logo-left -->
        <div class="logo-mmcs-ls">
          <div class="logo-mmcs-ls-l"></div>
          <div class="logo-mmcs-ls-r"></div>
        </div>
        <!-- top-logo-right -->
        <div class="btn-mmcs-ls">
          <div class="top-admin">
            <i @click="addModifyPassword"></i>
            <span :title="userInfo.account" @click="addModifyPassword">{{userInfo.account}}</span>
          </div>
          <div class="top-exit" @click="cancelLogin">
            <i></i>
            <span>退出</span>
          </div>
        </div>
      </div>
      <!-- content -->
      <div class="mmcs-bottom">
        <!-- 左侧列表 -->
        <div class="content-left-list">
          <el-menu
            router
            default-active="2"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
          >
            <el-menu-item
              index="/enterpriseTrend"
              @click="showListLiColor('企业趋势')"
              :class="{isActive:('企业趋势' === showHide)}"
              v-if="page.page1"
            >
              <i class="left-list-font-1"></i>企业趋势
            </el-menu-item>
            <el-menu-item
              index="/enterpriseStatistics"
              @click="showListLiColor('企业统计')"
              :class="{isActive:('企业统计' === showHide)}"
              v-if="page.page2"
            >
              <i class="left-list-font-2"></i>企业统计
            </el-menu-item>
            <el-menu-item
              index="/enterpriseOrder"
              @click="showListLiColor('企业订单')"
              :class="{isActive:('企业订单' === showHide)}"
              v-if="page.page3"
            >
              <i class="left-list-font-3"></i>企业订单
            </el-menu-item>
            <el-menu-item
              index="/enterpriseManage"
              @click="showListLiColor('企业管理')"
              :class="{isActive:('企业管理' === showHide)}"
              v-if="page.page4"
            >
              <i class="left-list-font-4"></i>企业管理
            </el-menu-item>
            <el-menu-item
              index="/enterpriseWebsite"
              @click="showListLiColor('企业网站')"
              :class="{isActive:('企业网站' === showHide)}"
              v-if="page.page5"
            >
              <i class="left-list-font-5"></i>企业网站
            </el-menu-item>
            <el-menu-item
              index="/companyObserve"
              @click="showListLiColor('企业观察')"
              :class="{isActive:('企业观察' === showHide)}"
              v-if="page.page8"
            >
              <i class="el-icon-view"></i>企业观察
            </el-menu-item>
            <el-menu-item
              index="/systemSetup"
              @click="showListLiColor('系统设置')"
              :class="{isActive:('系统设置' === showHide)}"
              v-if="page.page6"
            >
              <i class="left-list-font-6"></i>系统设置
            </el-menu-item>
            <el-menu-item
              index="/bgSet"
              @click="showListLiColor('后台设置')"
              :class="{isActive:('后台设置' === showHide)}"
              v-if="page.page7"
            >
              <i class="left-list-font-7"></i>后台设置
            </el-menu-item>
          </el-menu>
        </div>

        <!-- 右侧变化区域 -->
        <div class="content-right-view">
          <div>
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Socket, Channel } from 'phoenix'
import bus from '../../common/commonVue.js'
export default {
  data() {
    return {
      //控制左边列表的显示样式
      showHide: '',
      //获取用户信息
      userInfo: '',
      page: {
        page1: false,
        page2: false,
        page3: false,
        page4: false,
        page5: false,
        page6: false,
        page7: false,
        page8: false
      },
      socket: null
    }
  },
  mounted() {},
  created() {
    // console.log(this.$router.options.routes);
    // console.log(this.$route.matched);
    //设置页面刷新时左边列表默认点击处
    if (window.location.hash == '#/enterpriseTrend') {
      this.showHide = '企业趋势'
    } else if (window.location.hash == '#/enterpriseStatistics') {
      this.showHide = '企业统计'
    } else if (window.location.hash == '#/enterpriseOrder') {
      this.showHide = '企业订单'
    } else if (window.location.hash == '#/enterpriseManage') {
      this.showHide = '企业管理'
    } else if (window.location.hash == '#/enterpriseWebsite') {
      this.showHide = '企业网站'
    } else if (window.location.hash == '#/systemSetup') {
      this.showHide = '系统设置'
    } else if (window.location.hash == '#/bgSet') {
      this.showHide = '后台设置'
    } else if (window.location.hash == '#/companyObserve') {
      this.showHide = '企业观察'
    }
    this.getUserInfo()
    this.connect()
  },
  destroyed() {
    console.log('destroyed', this.socket)
    if (this.socket) {
      this.socket.remove()
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
    //点击颜色改变
    showListLiColor(showOrHide) {
      this.showHide = showOrHide
    },
    get_jwt() {
      var cookieName = 'jwt='
      var cookieStart = document.cookie.indexOf(cookieName)
      if (cookieStart > -1) {
        var cookieEnd = document.cookie.indexOf(';', cookieStart)
        if (cookieEnd > -1) {
          return decodeURIComponent(document.cookie.substring(cookieStart + cookieName.length, cookieEnd))
        } else {
          return decodeURIComponent(document.cookie.substring(cookieStart + cookieName.length, document.cookie.length))
        }
      } else null
    },
    //获取用户信息
    getUserInfo() {
      this.$ajax.post('/api/my_info').then(res => {
        this.userInfo = res.data.data
        //console.log(this.userInfo);
        //console.log(this.userInfo.privileges.length)
        //console.log(this.page.page1)

        for (var i = 0; i < this.userInfo.privileges.length; i++) {
          var privilege = this.userInfo.privileges[i]
          if (privilege == 'company_trend') {
            this.page.page1 = true
          } else if (privilege == 'company_stats') {
            this.page.page2 = true
          } else if (privilege == 'company_orders') {
            this.page.page3 = true
          } else if (privilege == 'company_manage') {
            this.page.page4 = true
          } else if (privilege == 'company_website') {
            this.page.page5 = true
          } else if (privilege == 'system_manage') {
            this.page.page6 = true
          } else if (privilege == 'backoffice_manage') {
            this.page.page7 = true
          } else if (privilege == 'company_observe') {
            this.page.page8 = true
          }
        }
        //传递给app.vue
        bus.$emit('userinfo', this.userInfo)
      })
    },
    connect() {
      var baseURL = process.env.NODE_ENV === 'production' ? '' : 'ws://' + this.$localUrl
      if (this.socket == null) {
        this.socket = new Socket(baseURL + '/socket', { params: { token: this.get_jwt() } })
        this.socket.connect()
        global.channel = this.socket.channel('page', {})
        channel.join()
        console.log('join_channel:', channel)
        var that = this
        this.socket.onClose(function() {
          console.log('disconnected socket')
          that.cancelLogin()
          that.socket = null
        })
      }
    },
    cancelLogin() {
      window.sessionStorage.removeItem('routerAcc')
      this.socket.reconnectTimer.reset()
      channel.leave()
      this.socket.disconnect()
      this.$ajax.get('/api/sign_out/').then(res => {})
      if (this.delOrAdd == 0) {
        console.log(this.delOrAdd)
      }
      this.$router.push({ path: 'loginLs' })
    },
    // 打开添加账号弹出框
    addModifyPassword() {
      bus.$emit('openAddModifyPassword')
    }
  }
}
</script>

<style lang="scss">
//定义sass函数span
@function p2r($size) {
  @return $size/16 * 1rem;
}

html {
  height: 100%;
  body {
    height: 100%;
    #app {
      height: 100%;
      > div {
        height: 100%;
      }
    }
  }
}

.mmcs {
  display: flex;
  flex-direction: column;
  height: 100%; // top导航栏
  overflow: hidden;
  .mmcs-top {
    height: 63px;
    background: #fbfbfb;
    border-bottom: 2px solid #eee;
    box-shadow: 0 1px 1px #eee;
    overflow: hidden;
    position: relative; //top-logo-left
    .logo-mmcs-ls {
      display: flex;
      margin-top: 19px;
      margin-left: p2r(24);
      .logo-mmcs-ls-l {
        height: 24px;
        width: 31px;
        background: url('../../statics/img/icon@2x.png') no-repeat 0 -107px/ (52/24);
        background-size: 205px/ (61/31) 1120px/ (48/24);
      }
      .logo-mmcs-ls-r {
        width: 90px;
        height: 24px;
        background: url('../../statics/img/icon@2x.png') no-repeat 0 -215px/ (42/24);
        background-size: 205px/ (160/90) 1120px/ (38/24);
        margin-left: 2px;
      }
    } //top-logo-right
    .btn-mmcs-ls {
      position: absolute;
      right: p2r(78);
      top: 24px;
      display: flex;
      color: #65657a;

      .top-admin {
        margin-right: p2r(57);
        position: absolute;
        top: 1px;
        left: -90px;
        i {
          display: inline-block;
          width: 18px;
          height: 19px;
          background: url('../../statics/img/icon@2x.png') no-repeat -113px -727px;
          padding-right: p2r(8);
          vertical-align: bottom;
          position: absolute;
          left: -26px;
          top: -3px;
          cursor: pointer;
        }
        span {
          position: absolute;
          width: 46px;
          top: -2px;
          font-size: 16px;
          cursor: pointer;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }

      .top-exit {
        position: relative;
        cursor: pointer;
        i {
          display: inline-block;
          width: 17px;
          height: 19px;
          background: url('../../statics/img/icon@2x.png') no-repeat 0 -808px;
          padding-right: p2r(8);
          position: absolute;
          left: -25px;
          top: -1px;
          cursor: pointer;
        }
        span {
          position: absolute;
          width: 40px;
          top: -5px;
          font-size: 16px;
        }
      }
    }
  }
  .mmcs-bottom {
    flex: 1;
    display: flex;
    .content-left-list {
      width: 180px;
      height: 100%;
      background: #eff4f5;
      .el-menu {
        background: #eff4f5;
        li.el-menu-item {
          height: 60px;
          line-height: 60px;
          position: relative;
          padding-left: 72px !important;
          &.isActive {
            background: #20a499;
            color: #fff;
            i.left-list-font-1 {
              background: url('../../statics/img/icon@2x.png') no-repeat -112px -293px;
            }
            i.left-list-font-2 {
              background: url('../../statics/img/icon@2x.png') no-repeat -113px -349px;
            }
            i.left-list-font-3 {
              background: url('../../statics/img/icon@2x.png') no-repeat -113px -407px;
            }
            i.left-list-font-4 {
              background: url('../../statics/img/icon@2x.png') no-repeat -113px -464px;
            }
            i.left-list-font-5 {
              background: url('../../statics/img/icon@2x.png') no-repeat -113px -520px;
            }
            i.left-list-font-6 {
              background: url('../../statics/img/icon@2x.png') no-repeat -113px -577px;
            }
            i.left-list-font-7 {
              background: url('../../statics/img/icon@2x.png') no-repeat -112px -654px;
            }
          }
          &.is-active {
            background: #20a499;
            color: #fff;
            i.left-list-font-1 {
              background: url('../../statics/img/icon@2x.png') no-repeat -112px -293px;
            }
            i.left-list-font-2 {
              background: url('../../statics/img/icon@2x.png') no-repeat -113px -349px;
            }
            i.left-list-font-3 {
              background: url('../../statics/img/icon@2x.png') no-repeat -113px -407px;
            }
            i.left-list-font-4 {
              background: url('../../statics/img/icon@2x.png') no-repeat -113px -464px;
            }
            i.left-list-font-5 {
              background: url('../../statics/img/icon@2x.png') no-repeat -113px -520px;
            }
            i.left-list-font-6 {
              background: url('../../statics/img/icon@2x.png') no-repeat -113px -577px;
            }
            i.left-list-font-7 {
              background: url('../../statics/img/icon@2x.png') no-repeat -112px -654px;
            }
          }
          i {
            position: absolute;
            display: inline-block;

            top: 20px;
            left: 38px;
          }
          .left-list-font-1 {
            width: 16px;
            height: 16px;
            background: url('../../statics/img/icon@2x.png') no-repeat -1px -293px;
          }
          .left-list-font-2 {
            width: 12px;
            height: 18px;
            background: url('../../statics/img/icon@2x.png') no-repeat -1px -349px;
          }
          .left-list-font-3 {
            width: 14px;
            height: 16px;
            background: url('../../statics/img/icon@2x.png') no-repeat -1px -407px;
          }
          .left-list-font-4 {
            width: 16px;
            height: 15px;
            background: url('../../statics/img/icon@2x.png') no-repeat 0 -464px;
          }
          .left-list-font-5 {
            width: 18px;
            height: 16px;
            background: url('../../statics/img/icon@2x.png') no-repeat 0 -520px;
          }
          .left-list-font-6 {
            width: 17px;
            height: 16px;
            background: url('../../statics/img/icon@2x.png') no-repeat 0 -577px;
            top: 21px;
          }
          .left-list-font-7 {
            width: 15px;
            height: 15px;
            background: url('../../statics/img/icon@2x.png') no-repeat -1px -654px;
            top: 22px;
            left: 39px;
          }
        }
      }
    }
    .content-right-view {
      flex: 1;
      height: 100%;
      overflow: hidden;
      position: relative;
      > div {
        overflow-y: auto;
        height: 100%;
        width: 100%;
        position: absolute;
        right: -17px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// home.vue?64835b54